import React from 'react';
import {
  BooleanInput,
  DateField,
  FormDataConsumer,
  SelectInput,
  TextField,
  TextInput,
} from 'react-admin';
import get from 'lodash/get';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Tooltip from '@material-ui/core/Tooltip';
import List from '@material-ui/core/List';
import Grid from '@material-ui/core/Grid';
import StatusChipField from './StatusChipField';
import TypographyField from './TypographyField';

const ServicesExpansionPanelEdit = ({ source: sourcePrefix, record }) => (
  <Accordion style={{ width: '100%', boxShadow: 'none' }}>
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      aria-controls={`${sourcePrefix}-content`}
      id={`${sourcePrefix}-header`}
    >
      <FormDataConsumer>
        {({ formData }) => (
          <Grid container alignItems="center">
            <Grid item xs={6} sm={7} lg={9}>
              <TypographyField
                variant="body1"
                label={get(formData, `${sourcePrefix}.display_name`)}
              />
            </Grid>
            <Grid
              item
              xs={1}
              style={{ display: 'flex', justifyContent: 'flex-end' }}
            >
              {get(formData, `${sourcePrefix}.is_upsell`) && (
                <Tooltip title="Upsell">
                  <MonetizationOnIcon color="primary" />
                </Tooltip>
              )}
            </Grid>
            <Grid
              item
              xs={5}
              sm={4}
              lg={2}
              style={{ display: 'flex', justifyContent: 'flex-end' }}
            >
              <StatusChipField
                label="Status"
                record={get(formData, `${sourcePrefix}`)}
              />
            </Grid>
          </Grid>
        )}
      </FormDataConsumer>
    </AccordionSummary>
    <AccordionDetails>
      <List style={{ width: '100%' }}>
        <TextInput
          label="resources.service.fields.display_name"
          source={`${sourcePrefix}.display_name`}
          fullWidth
        />
        <ReadField
          label="Created At"
          source={`${sourcePrefix}.created_at`}
          isDate
        />
        <div>
          <StatusChipField record={record} />
        </div>
        <BooleanInput
          label="resources.service.fields.is_upsell"
          source={`${sourcePrefix}.is_upsell`}
          options={{ checkedIcon: <MonetizationOnIcon /> }}
        />
        <FormDataConsumer>
          {({ formData, ...rest }) => (
            <div>
              {formData &&
                (get(formData, `${sourcePrefix}.is_upsell`) ? (
                  <div>
                    <div>
                      <SelectInput
                        source={`${sourcePrefix}.upsell_status`}
                        resettable
                        label="Upsell Status"
                        choices={[
                          { id: 'pending', name: 'Pending' },
                          { id: 'approved', name: 'Approved' },
                          { id: 'rejected', name: 'Rejected' },
                          { id: 'future', name: 'Future' },
                        ]}
                        {...rest}
                      />
                    </div>
                    <div>
                      <SelectInput
                        source={`${sourcePrefix}.upsell_rejection_reason`}
                        label="Rejection Reason"
                        resettable
                        choices={[
                          { id: 'diy', name: 'DIY' },
                          { id: 'price', name: 'Price' },
                          { id: 'other_provider', name: 'Other Provider' },
                          { id: 'leased', name: 'Leased' },
                          { id: 'think_about', name: 'Think About' },
                          { id: 'rescheduled', name: 'Rescheduled' },
                          { id: 'no_reason', name: 'No Reason' },
                        ]}
                        {...rest}
                      />
                    </div>
                  </div>
                ) : null)}
            </div>
          )}
        </FormDataConsumer>
        <ReadField label="Tax Type" source={`${sourcePrefix}.c`} />
        <ReadField
          label="Total Charge $"
          source={`${sourcePrefix}.total_cost_dollars`}
        />
        <div>
          <TextInput
            label="resources.service.fields.parts_cost_dollars"
            source={`${sourcePrefix}.parts_cost_dollars`}
          />
        </div>
        <div>
          <TextInput
            label="resources.service.fields.labor_cost_dollars"
            source={`${sourcePrefix}.labor_cost_dollars`}
          />
        </div>
        <div>
          <TextInput
            label="resources.service.fields.labor_hours"
            source={`${sourcePrefix}.labor_hours`}
          />
        </div>
        <TextInput
          label="resources.service.fields.employee_note"
          source={`${sourcePrefix}.employee_note`}
          fullWidth
        />
      </List>
    </AccordionDetails>
  </Accordion>
);

const ReadField = ({ label, source, isDate }) => {
  if (isDate) {
    return (
      <FormDataConsumer>
        {({ formData }) => (
          <div style={{ marginTop: '16px', marginBottom: '8px' }}>
            <div style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
              <TypographyField variant="caption" label={label} />
            </div>
            <DateField
              style={{ fontSize: '1rem' }}
              source={source}
              record={formData}
              showTime
            />
          </div>
        )}
      </FormDataConsumer>
    );
  }
  return (
    <FormDataConsumer>
      {({ formData }) => (
        <div style={{ marginTop: '16px', marginBottom: '8px' }}>
          <div style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
            <TypographyField variant="caption" label={label} />
          </div>
          <TextField
            style={{ fontSize: '1rem' }}
            source={source}
            record={formData}
          />
        </div>
      )}
    </FormDataConsumer>
  );
};

ReadField.defaultProps = {
  isDate: false,
};

export default ServicesExpansionPanelEdit;
